import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import { TBrowserApiData } from '@/core/constants/event_types/additional_types';
import { TEventPageData } from '@/core/constants/event_types/base_mable_event';
import { DictUtils } from '@/core/event_logic/utils/dict_utils';

import { StorageHandler } from '../storage_handler';

export class PageDataHandler {
  private static readonly _storageHandler = new StorageHandler<TEventPageData>(
    'pageData',
    {
      dl: '',
      dt: '',
      mp: 0,
      pb: 0,
      phct: 0,
      pp: 0,
      qpar: {},
      rl: '',
    },
    EBrowserStorageType.LOCALSTORAGE,
  );

  private static _calculatePageBundleId(): number {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return Math.floor(10_000_000 + Math.random() * 90_000_000);
  }

  static incrementPageHitCount() {
    const pageData = DictUtils.validateAndFixStringArrayDict(
      this._storageHandler.get(),
    );
    pageData.phct += 1;
    this._storageHandler.set(pageData);
    return pageData;
  }

  static get(): TEventPageData {
    return this.incrementPageHitCount();
  }

  static setAfterPageLoad(
    browserData: Partial<TBrowserApiData>,
  ): TEventPageData {
    const pageData = DictUtils.validateAndFixStringArrayDict(
      this._storageHandler.get(),
    );
    pageData.dl = browserData.dl || pageData.dl;
    pageData.rl = browserData.rl || pageData.rl;
    pageData.dt = browserData.dt || pageData.dt;
    pageData.qpar = browserData.qpar || pageData.qpar;
    pageData.pp = browserData.pp || pageData.pp;
    pageData.mp = browserData.mp || pageData.mp;
    this._storageHandler.set(pageData);
    return pageData;
  }

  static setOnPageLoad(browserData: TBrowserApiData): TEventPageData {
    const newPageData: TEventPageData = {
      dl: browserData.dl,
      dt: browserData.dt,
      mp: browserData.mp,
      pb: this._calculatePageBundleId(),
      phct: 0,
      pp: browserData.pp,
      qpar: browserData.qpar,
      rl: browserData.rl,
    };
    const validatedPageData =
      DictUtils.validateAndFixStringArrayDict(newPageData);
    this._storageHandler.set(validatedPageData);
    return validatedPageData;
  }
}
